import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "@user/components/Header";
import Footer from "@user/components/Footer";
import { api } from "@/lib/api";
import { ArrowLeft, Clock } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function ArticleDetail() {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);

  useEffect(() => {
    api.get(`/articles/${slug}`).then((r) => setArticle(r.data)).catch(() => setArticle(null));
  }, [slug]);

  if (!article) {
    return (
      <div className="min-h-screen bg-[#FAFAFA]">
        <Header />
        <div className="max-w-3xl mx-auto p-8 text-center text-slate-500">Loading…</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <Header />
      <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <Link to="/articles" className="inline-flex items-center gap-1 text-sm text-slate-500 hover:text-[#1E3A8A] mb-4">
          <ArrowLeft size={14} /> Back to Knowledge Hub
        </Link>
        <span className="text-xs font-bold uppercase tracking-wider text-[#1E3A8A]">{article.category}</span>
        <h1 className="mt-2 text-3xl md:text-4xl font-extrabold text-slate-900 leading-tight" style={{ fontFamily: "Manrope" }}>
          {article.title}
        </h1>
        <p className="mt-3 text-slate-600 leading-relaxed">{article.summary}</p>
        <div className="mt-4 flex items-center gap-1 text-xs text-slate-500">
          <Clock size={12} /> {article.read_time} min read
        </div>

        <div className="mt-8 bg-white border border-slate-200 rounded-2xl p-6 md:p-8">
          <div className="prose prose-slate max-w-none text-slate-800 leading-relaxed whitespace-pre-wrap">
            {article.content}
          </div>
        </div>

        {article.faqs?.length > 0 && (
          <div className="mt-10">
            <h2 className="text-2xl font-extrabold text-slate-900" style={{ fontFamily: "Manrope" }}>Frequently Asked Questions</h2>
            <div className="mt-4 bg-white border border-slate-200 rounded-2xl px-6">
              <Accordion type="single" collapsible className="w-full" data-testid="faqs-accordion">
                {article.faqs.map((f, i) => (
                  <AccordionItem key={i} value={`i-${i}`}>
                    <AccordionTrigger className="text-left text-base font-semibold text-slate-900">{f.q}</AccordionTrigger>
                    <AccordionContent className="text-slate-700 leading-relaxed">{f.a}</AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          </div>
        )}
      </article>
      <Footer />
    </div>
  );
}
